import React from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../components/Logo";

export default function TermsOfService() {
  const navigate = useNavigate();
  return (
    <div style={s.wrapper}>
      <header style={s.header}>
        <div onClick={() => navigate("/app/")} style={{ cursor: "pointer" }}>
          <Logo size={28} showText={true} />
        </div>
      </header>
      <main style={s.main}>
        <h1 style={s.h1}>Terms of Service</h1>
        <p style={s.meta}>Last updated: January 1, 2025</p>

        <p style={s.p}>Please read these Terms of Service ("Terms") carefully before using BotSaathi. By accessing or using our platform, you agree to be bound by these Terms.</p>

        <h2 style={s.h2}>1. Acceptance of Terms</h2>
        <p style={s.p}>By creating an account or using BotSaathi's services, you confirm that you are at least 18 years old and agree to these Terms and our Privacy Policy.</p>

        <h2 style={s.h2}>2. Description of Service</h2>
        <p style={s.p}>BotSaathi provides a WhatsApp automation platform that allows businesses to deploy AI-powered chatbots, capture leads, and manage customer conversations via WhatsApp Business API.</p>

        <h2 style={s.h2}>3. Account Responsibilities</h2>
        <ul style={s.ul}>
          <li style={s.li}>You are responsible for maintaining the confidentiality of your account credentials.</li>
          <li style={s.li}>You must provide accurate business information during onboarding.</li>
          <li style={s.li}>You are responsible for all activities that occur under your account.</li>
          <li style={s.li}>You must comply with Meta's WhatsApp Business policies at all times.</li>
        </ul>

        <h2 style={s.h2}>4. Acceptable Use</h2>
        <p style={s.p}>You agree NOT to use BotSaathi to:</p>
        <ul style={s.ul}>
          <li style={s.li}>Send spam, bulk unsolicited messages, or misleading content.</li>
          <li style={s.li}>Violate any applicable laws or regulations.</li>
          <li style={s.li}>Infringe on intellectual property rights of others.</li>
          <li style={s.li}>Attempt to reverse-engineer or compromise the platform.</li>
          <li style={s.li}>Use the platform for any fraudulent or deceptive purpose.</li>
        </ul>

        <h2 style={s.h2}>5. Payment Terms</h2>
        <p style={s.p}>BotSaathi charges a one-time setup fee and a recurring monthly subscription. Payments are due in advance. Failure to pay may result in suspension of services. All fees are in Indian Rupees (INR) and are non-refundable except as stated in our Refund Policy.</p>

        <h2 style={s.h2}>6. Service Availability</h2>
        <p style={s.p}>We strive for 99% uptime but do not guarantee uninterrupted service. We are not liable for downtime caused by Meta's WhatsApp API, third-party services, or events beyond our control.</p>

        <h2 style={s.h2}>7. Intellectual Property</h2>
        <p style={s.p}>All content, code, and features of BotSaathi are the intellectual property of BotSaathi. You may not copy, modify, or distribute our platform without prior written consent.</p>

        <h2 style={s.h2}>8. Termination</h2>
        <p style={s.p}>We reserve the right to suspend or terminate your account for violations of these Terms, non-payment, or misuse of the platform, with or without prior notice.</p>

        <h2 style={s.h2}>9. Limitation of Liability</h2>
        <p style={s.p}>BotSaathi shall not be liable for any indirect, incidental, special, or consequential damages arising from use of our platform, including loss of business, revenue, or data.</p>

        <h2 style={s.h2}>10. Governing Law</h2>
        <p style={s.p}>These Terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of courts in Uttarakhand, India.</p>

        <h2 style={s.h2}>11. Changes to Terms</h2>
        <p style={s.p}>We may update these Terms at any time. Continued use of the platform after changes constitutes acceptance of the new Terms.</p>

        <h2 style={s.h2}>12. Contact</h2>
        <p style={s.p}>For questions about these Terms:<br />
        <a href="mailto:support@botsaathi.com" style={s.link}>support@botsaathi.com</a><br />
        Ramnagar, Uttarakhand, India</p>
      </main>
      <footer style={s.footer}>
        <span style={{ color: "#444" }}>© 2025 BotSaathi. All rights reserved.</span>
        <a href="/privacy-policy" style={s.footerLink}>Privacy Policy</a>
        <a href="/refund-policy" style={s.footerLink}>Refund Policy</a>
      </footer>
    </div>
  );
}

const s = {
  wrapper: { background: "#0a0a0a", minHeight: "100vh", color: "#d0d0d0" },
  header: { padding: "20px 40px", borderBottom: "1px solid #1a1a1a" },
  main: { maxWidth: 760, margin: "0 auto", padding: "60px 24px" },
  h1: { fontSize: 36, fontWeight: 700, color: "#fff", marginBottom: 8, fontFamily: "Georgia, serif" },
  h2: { fontSize: 20, fontWeight: 700, color: "#fff", marginTop: 36, marginBottom: 10 },
  meta: { fontSize: 13, color: "#555", marginBottom: 32 },
  p: { fontSize: 15, lineHeight: 1.8, color: "#888", marginBottom: 16 },
  ul: { paddingLeft: 20, marginBottom: 16 },
  li: { fontSize: 15, lineHeight: 1.8, color: "#888", marginBottom: 6 },
  link: { color: "#25d366", textDecoration: "none" },
  footer: { borderTop: "1px solid #1a1a1a", padding: "24px 40px", display: "flex", gap: 20, alignItems: "center", justifyContent: "center", flexWrap: "wrap" },
  footerLink: { fontSize: 13, color: "#555", textDecoration: "none" },
};
